import {useDispatch} from "react-redux";
import {useRedPill} from "Hooks/api/useRedPill";
import {updateShopBalance} from "Redux/actions/shop";
import {IS_LOGGED_IN, SHOP_ENABLED} from "Setup/config";

/**
 * The shop coin balance fetch on its own, deliberately kept out of useShop.
 *
 * The account poll refreshes the balance on every tick and the account menu shows
 * it on every page, but neither wants the rest of the shop. useAccount importing
 * useShop for this one function put the whole 27KB hook — and the redemption
 * analytics it pulls in — into the initial bundle for every player, including the
 * ones who never open /shop. This is the only part of useShop anything outside the
 * shop needs, so it lives here and useShop consumes it too.
 */
export default function useShopBalance() {
    const dispatch = useDispatch();
    const {execute: getBalance} = useRedPill("authorizedPaths.shop.getBalance");

    const updateBalance = async () => {
        if (!IS_LOGGED_IN || !SHOP_ENABLED) return;

        const res = await getBalance({});
        if (res?.code === 200) {
            const shopCoinBalance = res.data ?? null;
            if (shopCoinBalance !== null) {
                dispatch(updateShopBalance(shopCoinBalance?.amount, shopCoinBalance?.coinAbbreviation));
            }
        }
    };

    return {updateBalance};
}
